import api from '../api';

export const getRoles = async (projectId) => {
  const res = await api.get(`/roles/${projectId}`);
  return res.data;
};

export const createRole = async ({ projectId, name, regionIds, permissions, access, isLeadership, approver, validator, trackAttendance }) => {
  const res = await api.post(`/roles`, { name, permissions, regionIds, projectId, access, isLeadership, approver, validator, trackAttendance });
  return res.data;
};

export const generateRole = async ({ projectId, roleName, isLeadership, trackAttendance }) => {
  const res = await api.post(`/roles/generate`, { projectId, roleName, isLeadership, trackAttendance });
  return res.data;
};

export const updateRole = async ({ id, projectId, name, regionIds, permissions, access, isLeadership, approver, validator, trackAttendance }) => {
  const res = await api.put(`/roles/${id}`, { name, permissions, regionIds, projectId, access, isLeadership, approver, validator, trackAttendance });
  return res.data;
};

export const deleteRole = async (id) => {
  const res = await api.delete(`/roles/${id}`);
  return res.data;
};
